import apiClient from '../../../../Services/ApiClient';
import React, { useState } from 'react';
import { useEffectAsync } from '../../../../helpers';

interface Props {
	workplaceId: string;
	userId?: string;
	patientId?: string;
	fetchFavorite?: boolean;
	workplaceMemberUserRelationId?: string;
}

enum CreateCaseTarget {
	WORKPLACE_MEMBER = 1,
	WORKPLACE = 9,
}

const UserRelationButton: React.FC<Props> = ({
	workplaceId,
	userId,
	patientId,
	fetchFavorite = true,
	workplaceMemberUserRelationId,
}) => {
	const [relationId, setRelationId] = useState<string | undefined>(undefined);

	useEffectAsync(async () => {
		if (fetchFavorite) {
			const { data } = await apiClient.get(
				`/user-relations?relationUserId=${userId}&workplaceId=${workplaceId}&userId=${patientId}`,
			);

			if (data.length) {
				setRelationId(data[0].id);
			}
		} else {
			setRelationId(workplaceMemberUserRelationId);
		}
	}, []);

	const handleClick = async () => {
		const queryArgs = {
			relationUserId: userId ? userId : null,
			type: userId
				? CreateCaseTarget.WORKPLACE_MEMBER
				: CreateCaseTarget.WORKPLACE,
			workplaceId,
			userId: patientId,
		};
		if (relationId) {
			const { data } = await apiClient.delete(
				`/user-relations/${relationId}`,
				queryArgs,
			);

			if (data.ok) {
				setRelationId(undefined);
			}
		} else {
			const { data } = await apiClient.post('/user-relations', queryArgs);

			if (data.id) {
				setRelationId(data.id);
			}
		}
	};

	return (
		<a onClick={handleClick}>
			<div
				className={`user-card-with-favorite__icon-wrapper ${
					relationId ? 'active' : ''
				}`}
			>
				<i className='fa-solid fa-heart' />
			</div>
		</a>
	);
};

export default UserRelationButton;
